import { DATA_AGENTS_INDEXED_CONTRACTS_EDITOR_TOKENS } from '@/consts/data/agentsContracts'
import { DATA_CUSTOMERS_INDEXED_CONTRACTS_EDITOR_TOKENS } from '@/consts/data/customersContracts'
import store from '@/store'
import {
  CONTRACT_DELETE_ERROR,
  CONTRACT_PRICE_SIGNATURE_STR,
  CONTRACT_SENDER_ALREADY_SIGNED,
  CONTRACT_SIGN_ERROR,
  CONTRACT_STATUS_ACTIVE,
  CONTRACT_TYPES_CUSTOMER,
  GET_DIALOG_RECEIVER,
  GET_DIALOG_SENDER
} from '@/consts/data/contract'
import { $ui, dialogConfirm, loadingHandler, promiseConfirm, toast } from '@/utils/ui'
import {
  deleteAgencyCustomerContract,
  postAgencyCustomerContractSigningToken
} from '@/utils/api/agency/agencyContractsCustomer'
import { deleteAgencyAgentContract, postAgencyAgentContractSigningToken } from '@/utils/api/agency/agencyContractsAgent'
import { MODAL_EVENT_UPDATE_CONTRACT } from '@/consts/app'
import { modalContractSend, modalContractSignature } from '@/utils/ui/modal'

_.templateSettings.interpolate = /{{([\s\S]+?)}}/g

const isPendingSignature = ({ signedAtDate } = {}) => typeof signedAtDate === 'undefined'

export const generateHtmlEditorToken = (value, type) => {
  const { label } = (type === CONTRACT_TYPES_CUSTOMER
    ? DATA_CUSTOMERS_INDEXED_CONTRACTS_EDITOR_TOKENS[value] || { label: 'Variable inconnu' }
    : DATA_AGENTS_INDEXED_CONTRACTS_EDITOR_TOKENS[value] || { label: 'Variable inconnu' })
  return `<div class="editor_token row inline items-center" contenteditable="false" data-key="${value}">&nbsp;<span class="content">${label}</span>&nbsp;<i class="fa fa-times" onclick="this.parentNode.parentNode.removeChild(this.parentNode)"></i></div>`
}
/**
 * Transforme un texte avec des chips avec un texte avec des templates lodash
 * @returns {string}
 * @param text
 */
export const chipedTextToText = (text) => {
  const temp = document.createElement('div')
  temp.innerHTML = text
  Array.from(temp.getElementsByClassName('editor_token')).forEach((token) => {
    token.replaceWith(document.createTextNode(`{{ ${token.dataset.key} }}`))
  })
  return temp.innerHTML
}

export const textToHtml = (text, type) => {
  return text.replace(_.templateSettings.interpolate, (v, key) => generateHtmlEditorToken(_.trim(key), type))
}

/**
 * Transforme les variables avec les bonne données
 * @param text
 * @param data
 * @returns {*}
 */
export const textToDataHtml = (text = '', data = {}) => {
  const company = store.getters['user/company']
  const compiled = _.template(
    text.replace(_.templateSettings.interpolate,
      (v, key) => `<%- _.get(data, '${_.trim(key)}', '') %>`),
    { variable: 'data' }
  )
  return compiled({
    ...data,
    company
  })
}

export const contractDialogDelete = async (type, contract) => {
  await promiseConfirm('La suppression est définitive')
  return loadingHandler(async () => {
    let deleteResponse
    if (type === CONTRACT_TYPES_CUSTOMER) {
      deleteResponse = await deleteAgencyCustomerContract(contract.id)
    } else {
      deleteResponse = await deleteAgencyAgentContract(contract.id)
    }
    if (!('contract' in deleteResponse)) {
      toast.negative(CONTRACT_DELETE_ERROR)
      throw new Error(JSON.stringify(deleteResponse))
    }
    $ui.$emit(MODAL_EVENT_UPDATE_CONTRACT, [{ ...deleteResponse.contract }])
  })
}

export const contractDialogSign = (type, contract) => {
  if (contract.status === CONTRACT_STATUS_ACTIVE) {
    dialogConfirm(GET_DIALOG_SENDER(CONTRACT_PRICE_SIGNATURE_STR))
      .onOk(async () => {
        await loadingHandler(async () => {
          const signature = {
            contract,
            emails: [
              store.getters['user/customer'].email
            ]
          }

          modalContractSignature(signature, type, true)
            .then((modal) => {
              modal.on('done', () => {
                modal.hide()
              })
              modal.on('error', () => {
                toast.negative(CONTRACT_SIGN_ERROR)
                modal.hide()
              })
            })
        })
      })
    return
  }

  toast.info(CONTRACT_SENDER_ALREADY_SIGNED)
}

const getContractEmail = (type, contract) => {
  return type === CONTRACT_TYPES_CUSTOMER ? contract.customer.email : contract.agent.email
}

export const contractDialogSendForSignature = async (
  type,
  {
    signatures = [],
    ..._contract
  } = {}) => {
  const pendingSignature = signatures.find(isPendingSignature)
  if (pendingSignature) {
    try {
      await promiseConfirm('Une signature est déjà en attente. Renvoyer pour signature ?')
      return modalContractSend(type, _contract, pendingSignature)
    } catch (e) {}
  }
  const receiverEmail = getContractEmail(type, _contract)
  const receiverBefore = receiverEmail ? 'à' : type === CONTRACT_TYPES_CUSTOMER ? 'au' : 'à'
  await promiseConfirm(GET_DIALOG_RECEIVER(receiverEmail, CONTRACT_PRICE_SIGNATURE_STR, receiverBefore))
  await loadingHandler(async () => {
    const _signature = {
      contract: {
        id: _contract.id
      }
    }
    const {
      contract,
      signature
    } = await (type === CONTRACT_TYPES_CUSTOMER
      ? postAgencyCustomerContractSigningToken(_signature)
      : postAgencyAgentContractSigningToken(_signature))
    $ui.$emit(MODAL_EVENT_UPDATE_CONTRACT, [contract])
    await modalContractSend(type, _contract, signature)
  })
}
